function i(e, r = !1) {
  if (r)
    throw new Error(`ERROR! The value ${JSON.stringify(e)} should be of type never.`);
  return e;
}
export {
  i
};
